export default "__VITE_ASSET__n01JF7xb__"